import { COLORS } from "./constants";
import type { CrosshairPosition, ChartLayout } from "./types";
import type { ServerBasePrice } from "services/types";
import type { CandleWithFlag } from "./types";

export function drawCrosshair(
  ctx: CanvasRenderingContext2D,
  crosshairPos: CrosshairPosition,
  hoverCandleIndex: number,
  dataArr: (ServerBasePrice | CandleWithFlag)[],
  layout: ChartLayout,
) {
  const { left, right, top, bottom, width: w, height: h } = layout;
  const { x: crossX, y: crossY } = crosshairPos;

  ctx.strokeStyle = COLORS.crosshair;
  ctx.lineWidth = 1;
  ctx.setLineDash([4, 4]);
  ctx.beginPath();
  ctx.moveTo(left, crossY);
  ctx.lineTo(w - right, crossY);
  ctx.moveTo(crossX, top);
  ctx.lineTo(crossX, h - bottom);
  ctx.stroke();
  ctx.setLineDash([]);

  if (
    hoverCandleIndex < dataArr.length &&
    "open" in dataArr[hoverCandleIndex] &&
    "close" in dataArr[hoverCandleIndex]
  ) {
    const candle = dataArr[hoverCandleIndex];
    if (!("open" in candle) || !("high" in candle) || !("low" in candle)) return;

    const tooltipX = Math.min(crossX + 15, w - 150);
    const tooltipY = Math.max(10, crossY - 45);

    ctx.fillStyle = "rgba(17,24,39,0.95)";
    ctx.fillRect(tooltipX, tooltipY, 140, 90);
    ctx.strokeStyle = "rgba(255,255,255,0.1)";
    ctx.strokeRect(tooltipX, tooltipY, 140, 90);

    ctx.fillStyle = "#E5E7EB";
    ctx.font = "11px Arial";
    ctx.textAlign = "left";
    ctx.fillText(`O: ${candle.open.toFixed(5)}`, tooltipX + 16, tooltipY + 16);
    ctx.fillText(`H: ${candle.high.toFixed(5)}`, tooltipX + 16, tooltipY + 32);
    ctx.fillText(`L: ${candle.low.toFixed(5)}`, tooltipX + 16, tooltipY + 48);
    ctx.fillText(`C: ${candle.close.toFixed(5)}`, tooltipX + 16, tooltipY + 64);
    return;
  }

  if (
    hoverCandleIndex < dataArr.length &&
    !("open" in dataArr[hoverCandleIndex]) &&
    !("close" in dataArr[hoverCandleIndex])
  ) {
    const point = dataArr[hoverCandleIndex];
    const tooltipX = Math.min(crossX + 15, w - 150);
    const tooltipY = Math.max(10, crossY - 20);

    ctx.fillStyle = "rgba(17,24,39,0.95)";
    ctx.fillRect(tooltipX, tooltipY, 140, 40);
    ctx.strokeStyle = "rgba(255,255,255,0.1)";
    ctx.strokeRect(tooltipX, tooltipY, 140, 40);

    ctx.fillStyle = "#E5E7EB";
    ctx.font = "11px Arial";
    ctx.textAlign = "left";
    ctx.fillText(`Price: ${point.price.toFixed(5)}`, tooltipX + 16, tooltipY + 16);
  }
}
